// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section {
  height: 89svh;
}

.blurTeste {
  transition: opacity 0.25s ease-in-out;
}

.menu__mobile__Mainfooter_links {
  display: grid;
}

/* @keyframes growAnimation {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1);
  }
}

.grid-item {
  transition: transform 0.3s ease-in-out;
}

.grid-item:hover {
  animation: 0.3s forwards;
} */

.carousel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.carousel-nav {
  position: absolute;
  display: flex;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

.carousel-nav img {
  width: 10px;
  height: auto;
  z-index: 100;
  cursor: pointer;
}

.carousel-nav img:nth-child(1) {
  position: absolute;
  left: 2em;
}

.carousel-nav img:nth-child(2) {
  position: absolute;
  right: 2em;
}

.carousel-inner {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease; /* Add a transition for the transform property */
}

.carousel-item {
  position: relative;
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: 0.5s ease-in-out;
}

.carousel-item.active {
  opacity: 1;
  transition: opacity 0.5s ease;
}

.carousel-item:not(.active) {
  opacity: 0;
  pointer-events: none; /* Disable interaction with inactive items */
  transition: opacity 0.5s ease;
}

.Carousel__Info {
  position: absolute;
  bottom: 2.5%;
  left: 15.7%;
  width: 100vw;
  z-index: 1; /* Place it on top of the images or videos */
  color: white;
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  justify-content: center;
  align-items: start;
}

.carousel-item img,
.carousel-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-item::before,
.carousel-item::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.45) 0%,
    rgba(0, 0, 0, 0.2) 15%,
    rgba(0, 0, 0, 0.15) 50%,
    rgba(0, 0, 0, 0.2) 85%,
    rgba(0, 0, 0, 0.45) 100%
  );
  pointer-events: all;
}

.carousel-item::before {
  top: 0;
}

.carousel-item::after {
  bottom: 0;
}

.main__Grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
}

.main__Grid__item {
  text-align: center;
  width: clamp(100%, 100%, 100%);
  height: auto;
  position: relative;
}

.card__img {
  max-width: 100%;
  height: auto;
}

.project-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px;
  text-align: left; /* Align text to the left */
  font-size: 21px;
  font-weight: bolder;
  text-transform: lowercase;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  opacity: 0;
  pointer-events: none; /* Allow clicks to go through the title */
}

.card__img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
}

.loaded {
  object-fit: cover;
}

.filter__all {
  grid-column: 1 / 2;
  display: flex;
  justify-content: space-between;
  min-width: 314px;
  color: black;
}

.filter__all div {
  cursor: pointer;
}

.filter__all div:hover {
  opacity: 90%;
}

.filter__container {
  grid-column: 2 / 5;
  display: flex;
  justify-content: space-between;
  min-width: 314px;
  color: black;
}

.filter__container div {
  cursor: pointer;
}

.filter__active {
  opacity: 0.95 !important;
  /* Add any other styles for the "active" state */
}

.test__test h1 {
  cursor: pointer;
}

.More__Projects__Grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  margin: 0 auto;
  padding-top: 50px;
  width: -moz-fit-content;
  width: fit-content;
  justify-items: center;
  padding-bottom: 50px;
  cursor: pointer;
}

.More__Projects__Grid p {
  font-size: 18px;
  font-weight: bolder;
  grid-column: 1 / 2;
}

.grid-container__test {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  padding-top: 40px;
  padding-bottom: 20px;
  font-size: 18px;
  position: relative;
}

.info__Grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  align-items: end;
  position: absolute;
  left: 15.6%;
  bottom: 10.5%;
}

.info__item {
  width: max-content;
}

.info__item:nth-child(1) {
  grid-column: 1 / 2;
  color: white;
}

.info__item:nth-child(2) {
  grid-column: 3 / 4;
  /* white-space:nowrap; */
  color: white;
}

.info__item:nth-child(3) {
  grid-column: 4 / 5;
  text-align: right;
  justify-self: right;
  color: white;
}

.info__item h1 {
  font-size: 18px;
  font-weight: bold;
}

.info__item p {
  font-size: 18px;
  font-weight: normal;
}

.grid-container__footer {
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 1fr));
  grid-gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  margin-top: 2.5em;
  padding-bottom: 2.5em;
}

.footer__logos__test {
  grid-column: 1 / 2;
  display: flex;
  width: clamp(150px, 100%, 100%);
  align-items: end;
  justify-content: left;
  gap: 2em;
}

.footer__logos__test div {
  height: 3em;
}

.footer__logos__test div img {
  height: 100%;
  width: auto !important;
}

.footer__links__test {
  grid-column: 2 / 3;
  display: flex;
  justify-content: space-between;
  width: clamp(150px, 100%, 100%);
  align-items: end;
}

.footer__links__test div p:hover {
  opacity: 90%;
  cursor: pointer;
}

.footer__links__test p {
  font-size: 18px;
  opacity: 40%;
}

.footer__links__test span {
  font-size: 18px;
  opacity: 40%;
}

.gradient {
  background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8));
}

.Awards__Info__Grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  position: relative;
  height: 86.5svh;
  align-items: end;
}

.awardsInfo {
  grid-column: 3 / 5;
  gap: 1.5em;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(60px, 60px));
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}

.awardsInfo div img {
  opacity: 90%;
  max-height: 60px;
  height: 100%;
}

.ProjectInfo__Grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  padding-top: 20px;
  justify-items: center;
}

.ProjectInfo__Grid div {
  grid-column: 1 / 5;
}

.ProjectInfo__Text {
  grid-column: 3 / 5 !important;
  width: clamp(100%, 100%, 100%);
  line-height: normal;
  padding: 20px 0 20px 0;
}

.ProjectInfo__Text h1 {
  font-size: 34px;
  font-weight: bold;
  padding-bottom: 0.5em;
}

.ProjectInfo__Text p {
  font-size: 24px;
  font-weight: normal;
  opacity: 60%;
}

.Tech__Info__Grid {
  display: grid;
  grid-template-columns: repeat(8, minmax(30px, 1fr));
  gap: 20px;
  margin: 0 auto;
  padding: 0;
  max-width: 68.6%;
  padding-top: 2.5em;
  padding-bottom: 100px;
}

.Tech__Info__Grid h1 {
  font-size: clamp(18px, 36px, 36px);
  font-weight: bold;
  line-height: 50px;
}

.Tech__Info__Grid h2 {
  font-size: 28px;
  font-weight: normal;
  opacity: 60%;
}

.Tech__Info__Grid p {
  font-size: 18px;
  font-weight: normal;
}

.Tech__Info__Grid h3 {
  font-size: 18px;
  font-weight: bold;
}

.TechInfo__left {
  grid-column: 1 / 4;
  width: clamp(100%, 100%, 100%);
}

.TechInfo__right {
  grid-column: 4 / 9 !important;
  width: clamp(100%, 100%, 100%);
  display: grid;
  gap: 5px;
  grid-template-columns: 1fr 4fr;
  align-items: start;
  justify-items: start;
}

.TechInfo__right p {
  line-height: 25px;
}

.TechInfo__right div {
  padding: 0.5em 0 1.5em 0;
}

.NextProject {
  max-width: 68.6%;
  margin: 0 auto;
  padding: 0;
  margin-bottom: 12.5em;
}

.line__New {
  background: rgba(0, 0, 0, 0.5);
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.5);
  height: 1px;
  cursor: pointer;
}

.line__New:hover {
  background: red;
  color: red;
  border-color: red;
  transition: 1s;
}

.NextProject h3 {
  font-size: 24px;
  font-weight: normal;
}

.NextProject h1 {
  font-size: 36px;
  font-weight: bolder;
  opacity: 100%;
  line-height: 50px;
}

.NextProject h2 {
  font-size: 28px;
  font-weight: normal;
}

.NextProject__Info {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 20px;
  margin: 0 auto;
  padding: 0;
  padding-top: 20px;
}

.line__Project {
  pointer-events: none;
}

.NextProject__Info h3 {
  pointer-events: auto;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.NextProject__Title {
  grid-column: 3 / 5;
  color: black !important;
  cursor: pointer;
}

.Top_Arrow {
  display: grid;
  justify-items: center;
  align-items: end;
  cursor: pointer;
  position: fixed;
  right: 7.5%;
  bottom: 28.25%;
}

.Top_Arrow p {
  font-size: 18px;
  font-weight: bolder;
}

.Top_Arrow img {
  margin-bottom: 0.5em;
}

.Top__Arrow__Home {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: end;
  cursor: pointer;
  position: fixed;
  bottom: 15em;
  left: 86.3%;
}

.Top__Arrow__Home p {
  font-size: 18px;
  font-weight: bolder;
  grid-column: 1 / 4;
}

.Top__Arrow__Home img {
  margin-bottom: 0.5em;
  grid-column: 1 / 4;
}

@media all and (min-width: 1700px) {
  .grid-container__footer__mobile__home {
    display: none;
  }

  #mobile__Info {
    display: none;
  }

  .grid-container__filter__mobile {
    display: none;
  }
}

@media all and (min-width: 1440px) and (max-width: 1700px) {
  .navbar-container__test__Logo {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    gap: 20px;
    margin: 0 auto;
    padding: 0;
    padding-top: 2.5em;
    align-content: center;
    align-items: end;
    position: sticky;
    top: 0;
    z-index: 2;
  }
  #mobile__Info {
    display: none !important;
  }

  .grid-container__filter__mobile {
    display: none !important;
  }

  .grid-container__footer__mobile__home {
    display: none !important;
  }
}

@media all and (min-width: 1025px) and (max-width: 1440px) {
  #Top__Arrow {
    display: none !important;
  }

  .navbar-container__test__Logo {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    gap: 20px;
    max-width: 80%;
    margin: 0 auto;
    padding: 0;
    padding-top: 2.5em;
    align-content: center;
    align-items: end;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .Carousel__Info {
    position: absolute;
    bottom: 2.5%;
    left: 10%;
    width: 100vw;
    max-width: 80% !important;
    z-index: 1; /* Place it on top of the images or videos */
    color: white;
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    justify-content: center;
    align-items: start;
  }

  .info__item__3 {
    justify-self: right;
  }

  .grid-container__filter__mobile {
    display: none !important;
  }

  .grid-container__test {
    max-width: 80% !important;
  }

  .main__Grid {
    max-width: 80% !important;
  }

  .More__Projects__Grid {
    max-width: 80% !important;
  }

  .grid-container__footer {
    max-width: 80% !important;
  }

  .footer__logos__test {
    grid-column: 1 / 2;
    display: flex;
    width: clamp(150px, 100%, 100%);
    align-items: end;
    justify-content: left;
    gap: 2em;
  }

  .footer__logos__test div {
    height: 2em;
  }

  .footer__links__test {
    grid-column: 2 / 3;
    display: flex;
    justify-content: space-between;
    width: clamp(150px, 100%, 100%);
    align-items: end;
    gap: 0.5em;
  }

  .footer__links__test div span {
    font-size: 13px;
  }

  .footer__links__test div p {
    font-size: 13px;
  }

  .grid-container__footer__mobile__home {
    display: none !important;
  }
}

@media all and (min-width: 769px) and (max-width: 1024px) {
  #Top__Arrow {
    display: none !important;
  }

  .NextProject h3 {
    font-size: 12px;
    font-weight: normal;
  }

  .NextProject h1 {
    font-size: 18px;
    font-weight: bolder;
    opacity: 100%;
    line-height: normal;
  }

  .NextProject h2 {
    font-size: 18px;
    font-weight: normal;
  }

  .main__Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
  }

  .Carousel__Info {
    position: absolute;
    bottom: 2.5%;
    left: 5.25%;
    width: 100vw;
    max-width: 89.5% !important;
    z-index: 1; /* Place it on top of the images or videos */
    color: white;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    justify-content: center;
    align-items: start;
  }

  .info__item:nth-child(1) {
    grid-column: 1 /2;
    grid-row: 1 / 2;
    width: auto;
  }

  .info__item:nth-child(2) {
    grid-column: 1 /2;
    grid-row: 2 / 3;
    width: auto;
  }

  .info__item:nth-child(3) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .filter__container {
    grid-column: 2 / 5;
    display: flex;
    justify-content: space-between;
    min-width: 150px;
    color: black;
    opacity: 40%;
    position: relative;
  }

  .grid-container__test {
    display: none;
  }

  .grid-container__filter__mobile {
    display: grid;
    grid-template-rows: 1fr;
    margin: 0 auto;
    padding: 25px 0 25px 0;
    max-width: 89.5%;
    gap: 10px;
    color: black;
    position: relative;
  }

  .test__test {
    display: flex;
    justify-content: space-between;
  }

  .grid-container__filter__mobile h1 {
    font-size: 3vw;
    font-weight: normal;
  }

  .info__Grid {
    display: none;
  }

  .info__Grid__Mobile {
    display: grid;
    grid-template-rows: 1fr;
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: absolute;
    bottom: 0;
    left: 5.25%;
    align-items: end;
    padding-bottom: 5.25%;
    transition: opacity 0.5s ease-in-out;
  }

  .info__item__Mobile {
    color: white;
    align-items: end;
  }

  .info__item__Mobile:nth-child(1) {
    display: inline-flex;
    color: white;
    align-items: start;
  }

  .info__item__Mobile__extra {
    margin-left: auto;
  }

  .info__item__Mobile h1 {
    font-size: clamp(4vw, 100%, 4vw);
    font-weight: bold;
  }

  .info__item__Mobile p {
    font-size: clamp(4vw, 100%, 4vw);
    font-weight: normal;
  }

  .info__item__Mobile:nth-child(2) h1 {
    color: white;
    font-size: clamp(4vw, 100%, 4vw);
  }

  .info__item__Mobile:nth-child(2) p {
    color: white;
    font-size: clamp(4vw, 100%, 4vw);
  }

  .grid-container__footer {
    display: none !important;
  }

  .grid-container__footer__mobile__home {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 2em 0 1em 0;
    width: 89.5%;
    color: black;
  }

  .footer__logos__test {
    grid-column: 1 / 2;
    display: flex;
    justify-content: space-between;
    width: clamp(150px, 100%, 100%);
  }

  .Awards__Info__Grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    height: 87.5svh;
    align-items: end;
  }

  .awardsInfo {
    grid-column: 1 / 5;
    gap: 1em;
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(50px, 50px)
    ); /* Use auto-fit */
    margin: 0 auto; /* Update this line for horizontal centering */
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    justify-content: center;
  }

  .ProjectInfo__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 20px;
    justify-items: center;
  }

  .ProjectInfo__Grid div {
    grid-column: 1 / 3;
  }

  .ProjectInfo__Text {
    grid-column: 1 / 3 !important;
    width: clamp(310px, 100%, 100%);
    padding: 1em 0 1em 0;
  }

  .ProjectInfo__Text h1 {
    font-size: 18px;
    font-weight: bold;
  }

  .ProjectInfo__Text p {
    font-size: 14px;
    font-weight: normal;
    opacity: 60%;
  }

  .Tech__Info__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 1.5em;
  }

  .Tech__Info__Grid h1 {
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
  }

  .Tech__Info__Grid h2 {
    font-size: 16px;
    font-weight: normal;
    opacity: 60%;
  }

  .Tech__Info__Grid p {
    font-size: 16px;
    font-weight: normal;
  }

  .Tech__Info__Grid h3 {
    font-size: 16px;
    font-weight: bold;
  }

  .TechInfo__left {
    grid-column: 1 / 3;
    width: clamp(150px, 100%, 100%);
    padding-bottom: 1em;
  }

  .TechInfo__left h2 {
    padding-left: 0;
  }

  .TechInfo__right {
    grid-column: 1 / 3 !important;
    width: clamp(310px, 100%, 100%);
    display: grid;
    grid-template-columns: 1fr 4fr;
    padding-bottom: 2.5em;
    align-items: start;
  }

  .TechInfo__right div {
    padding: 0em 0 0em 0;
  }

  .NextProject {
    max-width: 89.5%;
    margin: 0 auto;
    margin-bottom: 0px;
    padding: 0;
    margin-bottom: 5em;
  }

  .NextProject__Info {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 0px;
    margin: 0 auto;
    padding: 0;
    padding-top: 1.5em;
    padding-bottom: 3em;
  }

  .NextProject__Title {
    grid-column: 2 / 3;
    justify-self: end;
  }

  .NextProject__Title h2 {
    padding-left: 0;
  }

  .Top_Arrow {
    display: none !important;
  }

  .Top_Arrow__Home {
    display: none !important;
  }
}

@media all and (min-width: 426px) and (max-width: 768px) {
  .NextProject h3 {
    font-size: 12px;
    font-weight: normal;
  }

  .NextProject h1 {
    font-size: 18px;
    font-weight: bolder;
    opacity: 100%;
    line-height: normal;
  }

  .NextProject h2 {
    font-size: 18px;
    font-weight: normal;
  }

  .Carousel__Info {
    position: absolute;
    bottom: 2.5%;
    left: 5.25%;
    width: 100vw;
    max-width: 89.5% !important;
    z-index: 1; /* Place it on top of the images or videos */
    color: white;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    justify-content: center;
    align-items: start;
  }

  .info__item:nth-child(1) {
    grid-column: 1 /2;
    grid-row: 1 / 2;
    width: auto;
  }

  .info__item:nth-child(2) {
    grid-column: 1 /2;
    grid-row: 2 / 3;
    width: auto;
  }

  .info__item:nth-child(3) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .Awards__Info__Grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    height: 87.5svh;
    align-items: end;
  }

  .Tech__Info__Grid h2 {
    font-size: 14px;
    font-weight: normal;
    opacity: 60%;
  }

  .Tech__Info__Grid p {
    font-size: 14px;
    font-weight: normal;
  }

  .Tech__Info__Grid h3 {
    font-size: 14px;
    font-weight: bold;
  }

  .awardsInfo {
    grid-column: 1 / 2;
    gap: 1em;
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(50px, 50px)
    ); /* Use auto-fit */
    margin: 0 auto; /* Update this line for horizontal centering */
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    justify-content: center;
  }

  .NextProject {
    max-width: 89.5%;
    margin: 0 auto;
    margin-bottom: 0px;
    padding: 0;
    margin-bottom: 5em;
  }

  .NextProject__Info {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 0px;
    margin: 0 auto;
  }

  .NextProject__Title {
    grid-column: 2 / 3;
    justify-self: end;
  }

  .NextProject__Title h2 {
    padding-left: 0;
  }
}

@media all and (max-width: 768px) {
  #Top__Arrow {
    display: none !important;
  }

  .NextProject h3 {
    font-size: 12px;
    font-weight: normal;
  }

  .NextProject h1 {
    font-size: 18px;
    font-weight: bolder;
    opacity: 100%;
    line-height: normal;
  }

  .NextProject h2 {
    font-size: 18px;
    font-weight: normal;
  }

  .main__Grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
  }

  .Carousel__Info {
    max-width: 89.5%;
  }

  .filter__container {
    grid-column: 2 / 5;
    display: flex;
    justify-content: space-between;
    min-width: 150px;
    color: black;
    opacity: 40%;
    position: relative;
  }

  .grid-container__test {
    display: none;
  }

  .grid-container__filter__mobile {
    display: grid;
    grid-template-rows: 1fr;
    margin: 0 auto;
    padding: 25px 0 25px 0;
    max-width: 89.5%;
    gap: 10px;
    color: black;
    position: relative;
  }

  .test__test {
    display: flex;
    justify-content: space-between;
  }

  .grid-container__filter__mobile h1 {
    font-size: 4vw;
    font-weight: normal;
  }

  .info__Grid {
    display: none;
  }

  .info__Grid__Mobile {
    display: grid;
    grid-template-rows: 1fr;
    grid-gap: 20px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: absolute;
    bottom: 0;
    left: 5.25%;
    align-items: end;
    padding-bottom: 5.25%;
    transition: opacity 0.5s ease-in-out;
  }

  .info__item__Mobile {
    color: white;
    align-items: end;
  }

  .info__item__Mobile:nth-child(1) {
    display: inline-flex;
    color: white;
    align-items: start;
  }

  .info__item__Mobile__extra {
    margin-left: auto;
  }

  .info__item__Mobile h1 {
    font-size: clamp(4vw, 100%, 4vw);
    font-weight: bold;
  }

  .info__item__Mobile p {
    font-size: clamp(4vw, 100%, 4vw);
    font-weight: normal;
  }

  .info__item__Mobile:nth-child(2) h1 {
    color: white;
    font-size: clamp(4vw, 100%, 4vw);
  }

  .info__item__Mobile:nth-child(2) p {
    color: white;
    font-size: clamp(4vw, 100%, 4vw);
  }

  .grid-container__footer {
    display: none !important;
  }

  .grid-container__footer__mobile__home {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    grid-gap: 10px;
    margin: 0 auto;
    padding: 2em 0 1em 0;
    width: 89.5%;
    color: black;
  }

  .footer__logos__test {
    grid-column: 1 / 2;
    display: flex;
    justify-content: space-between;
    width: clamp(150px, 100%, 100%);
  }

  .ProjectInfo__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 20px;
    justify-items: center;
  }

  .ProjectInfo__Grid div {
    grid-column: 1 / 3;
  }

  .ProjectInfo__Text {
    grid-column: 1 / 3 !important;
    width: clamp(310px, 100%, 100%);
    padding: 1em 0 1em 0;
  }

  .ProjectInfo__Text h1 {
    font-size: 18px;
    font-weight: bold;
  }

  .ProjectInfo__Text p {
    font-size: 14px;
    font-weight: normal;
    opacity: 60%;
  }

  .Tech__Info__Grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    padding-top: 1.5em;
  }

  .Tech__Info__Grid h1 {
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
  }

  .Tech__Info__Grid h2 {
    font-size: 14px;
    font-weight: normal;
    opacity: 60%;
  }

  .Tech__Info__Grid p {
    font-size: 14px;
    font-weight: normal;
  }

  .Tech__Info__Grid h3 {
    font-size: 14px;
    font-weight: bold;
  }

  .TechInfo__left {
    grid-column: 1 / 3;
    width: clamp(150px, 100%, 100%);
    padding-bottom: 1em;
  }

  .TechInfo__left h2 {
    padding-left: 0;
  }

  .TechInfo__right {
    grid-column: 1 / 3 !important;
    width: clamp(310px, 100%, 100%);
    display: grid;
    grid-template-columns: 1fr 4fr;
    padding-bottom: 2.5em;
    align-items: start;
  }

  .TechInfo__right div {
    padding: 0em 0 0em 0;
  }

  .Top_Arrow {
    display: none !important;
  }

  .Top_Arrow__Home {
    display: none !important;
  }
}

@media all and (min-width: 376px) and (max-width: 425px) {
  .NextProject h3 {
    font-size: 12px;
    font-weight: normal;
  }

  .NextProject h1 {
    font-size: 18px;
    font-weight: bolder;
    opacity: 100%;
    line-height: normal;
  }

  .NextProject h2 {
    font-size: 18px;
    font-weight: normal;
  }

  .Carousel__Info {
    position: absolute;
    bottom: 2.5%;
    left: 5.25%;
    width: 100vw;
    max-width: 89.5% !important;
    z-index: 1; /* Place it on top of the images or videos */
    color: white;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    justify-content: center;
    align-items: start;
  }

  .info__item:nth-child(1) {
    grid-column: 1 /2;
    grid-row: 1 / 2;
    width: auto;
  }

  .info__item:nth-child(2) {
    grid-column: 1 /2;
    grid-row: 2 / 3;
    width: auto;
  }

  .info__item:nth-child(3) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .Awards__Info__Grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    height: 87.5svh;
    align-items: end;
  }

  .awardsInfo {
    grid-column: 1 / 2;
    gap: 1em;
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(50px, 50px)
    ); /* Use auto-fit */
    margin: 0 auto; /* Update this line for horizontal centering */
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    justify-content: center;
  }

  .NextProject {
    max-width: 89.5%;
    margin: 0 auto;
    margin-bottom: 0px;
    padding: 0;
    margin-bottom: 5em;
  }

  .NextProject__Info {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 0px;
    margin: 0 auto;
  }

  .NextProject__Title {
    grid-column: 2 / 3;
    justify-self: end;
  }

  .NextProject__Title h2 {
    padding-left: 0;
  }
}

@media all and (min-width: 321px) and (max-width: 375px) {
  .NextProject h3 {
    font-size: 12px;
    font-weight: normal;
  }

  .NextProject h1 {
    font-size: 18px;
    font-weight: bolder;
    opacity: 100%;
    line-height: normal;
  }

  .NextProject h2 {
    font-size: 18px;
    font-weight: normal;
  }

  .Carousel__Info {
    position: absolute;
    bottom: 2.5%;
    left: 5.25%;
    width: 100vw;
    max-width: 89.5% !important;
    z-index: 1; /* Place it on top of the images or videos */
    color: white;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    justify-content: center;
    align-items: start;
  }

  .info__item:nth-child(1) {
    grid-column: 1 /2;
    grid-row: 1 / 2;
    width: auto;
  }

  .info__item:nth-child(2) {
    grid-column: 1 /2;
    grid-row: 2 / 3;
    width: auto;
  }

  .info__item:nth-child(3) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .Awards__Info__Grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    height: 87.5svh;
    align-items: end;
  }

  .awardsInfo {
    grid-column: 1 / 2;
    gap: 1em;
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(50px, 50px)
    ); /* Use auto-fit */
    margin: 0 auto; /* Update this line for horizontal centering */
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    justify-content: center;
  }

  .NextProject {
    max-width: 89.5%;
    margin: 0 auto;
    margin-bottom: 0px;
    padding: 0;
    margin-bottom: 5em;
  }

  .NextProject__Info {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 0px;
    margin: 0 auto;
  }

  .NextProject__Title {
    grid-column: 2 / 3;
    justify-self: end;
  }

  .NextProject__Title h2 {
    padding-left: 0;
  }
}

@media all and (max-width: 320px) {
  .NextProject h3 {
    font-size: 12px;
    font-weight: normal;
  }

  .NextProject h1 {
    font-size: 18px;
    font-weight: bolder;
    opacity: 100%;
    line-height: normal;
  }

  .NextProject h2 {
    font-size: 18px;
    font-weight: normal;
  }

  .Carousel__Info {
    position: absolute;
    bottom: 2.5%;
    left: 5.25%;
    width: 100vw;
    max-width: 89.5% !important;
    z-index: 1; /* Place it on top of the images or videos */
    color: white;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 10px;
    margin: 0 auto;
    padding: 0;
    justify-content: center;
    align-items: start;
  }

  .info__item:nth-child(1) {
    grid-column: 1 /2;
    grid-row: 1 / 2;
    width: auto;
  }

  .info__item:nth-child(2) {
    grid-column: 1 /2;
    grid-row: 2 / 3;
    width: auto;
  }

  .info__item:nth-child(3) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .Awards__Info__Grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 0 auto;
    padding: 0;
    max-width: 89.5%;
    position: relative;
    height: 87.5svh;
    align-items: end;
  }

  .awardsInfo {
    grid-column: 1 / 2;
    gap: 1em;
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(50px, 50px)
    ); /* Use auto-fit */
    margin: 0 auto; /* Update this line for horizontal centering */
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    justify-content: center;
  }

  .NextProject {
    max-width: 89.5%;
    margin: 0 auto;
    margin-bottom: 0px;
    padding: 0;
    margin-bottom: 5em;
  }

  .NextProject__Info {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 0px;
    margin: 0 auto;
  }

  .NextProject__Title {
    grid-column: 2 / 3;
    justify-self: end;
  }

  .NextProject__Title h2 {
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,+BAA+B,EAAE,gDAAgD;AACnF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB,EAAE,4CAA4C;EAClE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU,EAAE,4CAA4C;EACxD,YAAY;EACZ,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;;GAOC;EACD,mBAAmB;AACrB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,gBAAgB,EAAE,2BAA2B;EAC7C,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kCAA0B;UAA1B,0BAA0B;EAC1B,UAAU;EACV,oBAAoB,EAAE,yCAAyC;AACjE;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,uBAAkB;EAAlB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;EACT,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;EAChC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,UAAU,EAAE,4CAA4C;IACxD,YAAY;IACZ,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,UAAU,EAAE,4CAA4C;IACxD,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,oCAAoC;EACtC;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb;;;KAGC,EAAE,iBAAiB;IACpB,cAAc,EAAE,8CAA8C;IAC9D,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,UAAU,EAAE,4CAA4C;IACxD,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb;;;KAGC,EAAE,iBAAiB;IACpB,cAAc,EAAE,8CAA8C;IAC9D,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,oCAAoC;EACtC;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,UAAU,EAAE,4CAA4C;IACxD,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb;;;KAGC,EAAE,iBAAiB;IACpB,cAAc,EAAE,8CAA8C;IAC9D,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,UAAU,EAAE,4CAA4C;IACxD,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb;;;KAGC,EAAE,iBAAiB;IACpB,cAAc,EAAE,8CAA8C;IAC9D,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,UAAU,EAAE,4CAA4C;IACxD,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,2BAA2B;IAC3B,cAAc;IACd,cAAc;IACd,UAAU;IACV,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb;;;KAGC,EAAE,iBAAiB;IACpB,cAAc,EAAE,8CAA8C;IAC9D,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["section {\r\n  height: 89svh;\r\n}\r\n\r\n.blurTeste {\r\n  transition: opacity 0.25s ease-in-out;\r\n}\r\n\r\n.menu__mobile__Mainfooter_links {\r\n  display: grid;\r\n}\r\n\r\n/* @keyframes growAnimation {\r\n  from {\r\n    transform: scale(1);\r\n  }\r\n  to {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.grid-item {\r\n  transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.grid-item:hover {\r\n  animation: 0.3s forwards;\r\n} */\r\n\r\n.carousel {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.carousel-nav {\r\n  position: absolute;\r\n  display: flex;\r\n  width: 100%;\r\n  height: auto;\r\n  margin: 0 auto;\r\n}\r\n\r\n.carousel-nav img {\r\n  width: 10px;\r\n  height: auto;\r\n  z-index: 100;\r\n  cursor: pointer;\r\n}\r\n\r\n.carousel-nav img:nth-child(1) {\r\n  position: absolute;\r\n  left: 2em;\r\n}\r\n\r\n.carousel-nav img:nth-child(2) {\r\n  position: absolute;\r\n  right: 2em;\r\n}\r\n\r\n.carousel-inner {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  transition: transform 0.5s ease; /* Add a transition for the transform property */\r\n}\r\n\r\n.carousel-item {\r\n  position: relative;\r\n  flex: 0 0 100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  transition: 0.5s ease-in-out;\r\n}\r\n\r\n.carousel-item.active {\r\n  opacity: 1;\r\n  transition: opacity 0.5s ease;\r\n}\r\n\r\n.carousel-item:not(.active) {\r\n  opacity: 0;\r\n  pointer-events: none; /* Disable interaction with inactive items */\r\n  transition: opacity 0.5s ease;\r\n}\r\n\r\n.Carousel__Info {\r\n  position: absolute;\r\n  bottom: 2.5%;\r\n  left: 15.7%;\r\n  width: 100vw;\r\n  z-index: 1; /* Place it on top of the images or videos */\r\n  color: white;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  justify-content: center;\r\n  align-items: start;\r\n}\r\n\r\n.carousel-item img,\r\n.carousel-item video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.carousel-item::before,\r\n.carousel-item::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-image: linear-gradient(\r\n    to bottom,\r\n    rgba(0, 0, 0, 0.45) 0%,\r\n    rgba(0, 0, 0, 0.2) 15%,\r\n    rgba(0, 0, 0, 0.15) 50%,\r\n    rgba(0, 0, 0, 0.2) 85%,\r\n    rgba(0, 0, 0, 0.45) 100%\r\n  );\r\n  pointer-events: all;\r\n}\r\n\r\n.carousel-item::before {\r\n  top: 0;\r\n}\r\n\r\n.carousel-item::after {\r\n  bottom: 0;\r\n}\r\n\r\n.main__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n}\r\n\r\n.main__Grid__item {\r\n  text-align: center;\r\n  width: clamp(100%, 100%, 100%);\r\n  height: auto;\r\n  position: relative;\r\n}\r\n\r\n.card__img {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.project-title {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  color: white;\r\n  padding: 10px;\r\n  text-align: left; /* Align text to the left */\r\n  font-size: 21px;\r\n  font-weight: bolder;\r\n  text-transform: lowercase;\r\n  backdrop-filter: blur(8px);\r\n  opacity: 0;\r\n  pointer-events: none; /* Allow clicks to go through the title */\r\n}\r\n\r\n.card__img {\r\n  width: 100%;\r\n  aspect-ratio: 1 / 1;\r\n  object-fit: contain;\r\n}\r\n\r\n.loaded {\r\n  object-fit: cover;\r\n}\r\n\r\n.filter__all {\r\n  grid-column: 1 / 2;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  min-width: 314px;\r\n  color: black;\r\n}\r\n\r\n.filter__all div {\r\n  cursor: pointer;\r\n}\r\n\r\n.filter__all div:hover {\r\n  opacity: 90%;\r\n}\r\n\r\n.filter__container {\r\n  grid-column: 2 / 5;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  min-width: 314px;\r\n  color: black;\r\n}\r\n\r\n.filter__container div {\r\n  cursor: pointer;\r\n}\r\n\r\n.filter__active {\r\n  opacity: 0.95 !important;\r\n  /* Add any other styles for the \"active\" state */\r\n}\r\n\r\n.test__test h1 {\r\n  cursor: pointer;\r\n}\r\n\r\n.More__Projects__Grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  grid-gap: 10px;\r\n  margin: 0 auto;\r\n  padding-top: 50px;\r\n  width: fit-content;\r\n  justify-items: center;\r\n  padding-bottom: 50px;\r\n  cursor: pointer;\r\n}\r\n\r\n.More__Projects__Grid p {\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n  grid-column: 1 / 2;\r\n}\r\n\r\n.grid-container__test {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  padding-top: 40px;\r\n  padding-bottom: 20px;\r\n  font-size: 18px;\r\n  position: relative;\r\n}\r\n\r\n.info__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  align-items: end;\r\n  position: absolute;\r\n  left: 15.6%;\r\n  bottom: 10.5%;\r\n}\r\n\r\n.info__item {\r\n  width: max-content;\r\n}\r\n\r\n.info__item:nth-child(1) {\r\n  grid-column: 1 / 2;\r\n  color: white;\r\n}\r\n\r\n.info__item:nth-child(2) {\r\n  grid-column: 3 / 4;\r\n  /* white-space:nowrap; */\r\n  color: white;\r\n}\r\n\r\n.info__item:nth-child(3) {\r\n  grid-column: 4 / 5;\r\n  text-align: right;\r\n  justify-self: right;\r\n  color: white;\r\n}\r\n\r\n.info__item h1 {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.info__item p {\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n}\r\n\r\n.grid-container__footer {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(320px, 1fr));\r\n  grid-gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  margin-top: 2.5em;\r\n  padding-bottom: 2.5em;\r\n}\r\n\r\n.footer__logos__test {\r\n  grid-column: 1 / 2;\r\n  display: flex;\r\n  width: clamp(150px, 100%, 100%);\r\n  align-items: end;\r\n  justify-content: left;\r\n  gap: 2em;\r\n}\r\n\r\n.footer__logos__test div {\r\n  height: 3em;\r\n}\r\n\r\n.footer__logos__test div img {\r\n  height: 100%;\r\n  width: auto !important;\r\n}\r\n\r\n.footer__links__test {\r\n  grid-column: 2 / 3;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: clamp(150px, 100%, 100%);\r\n  align-items: end;\r\n}\r\n\r\n.footer__links__test div p:hover {\r\n  opacity: 90%;\r\n  cursor: pointer;\r\n}\r\n\r\n.footer__links__test p {\r\n  font-size: 18px;\r\n  opacity: 40%;\r\n}\r\n\r\n.footer__links__test span {\r\n  font-size: 18px;\r\n  opacity: 40%;\r\n}\r\n\r\n.gradient {\r\n  background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8));\r\n}\r\n\r\n.Awards__Info__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  position: relative;\r\n  height: 86.5svh;\r\n  align-items: end;\r\n}\r\n\r\n.awardsInfo {\r\n  grid-column: 3 / 5;\r\n  gap: 1.5em;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(60px, 60px));\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  width: 100%;\r\n  height: fit-content;\r\n}\r\n\r\n.awardsInfo div img {\r\n  opacity: 90%;\r\n  max-height: 60px;\r\n  height: 100%;\r\n}\r\n\r\n.ProjectInfo__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  padding-top: 20px;\r\n  justify-items: center;\r\n}\r\n\r\n.ProjectInfo__Grid div {\r\n  grid-column: 1 / 5;\r\n}\r\n\r\n.ProjectInfo__Text {\r\n  grid-column: 3 / 5 !important;\r\n  width: clamp(100%, 100%, 100%);\r\n  line-height: normal;\r\n  padding: 20px 0 20px 0;\r\n}\r\n\r\n.ProjectInfo__Text h1 {\r\n  font-size: 34px;\r\n  font-weight: bold;\r\n  padding-bottom: 0.5em;\r\n}\r\n\r\n.ProjectInfo__Text p {\r\n  font-size: 24px;\r\n  font-weight: normal;\r\n  opacity: 60%;\r\n}\r\n\r\n.Tech__Info__Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(8, minmax(30px, 1fr));\r\n  gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  max-width: 68.6%;\r\n  padding-top: 2.5em;\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.Tech__Info__Grid h1 {\r\n  font-size: clamp(18px, 36px, 36px);\r\n  font-weight: bold;\r\n  line-height: 50px;\r\n}\r\n\r\n.Tech__Info__Grid h2 {\r\n  font-size: 28px;\r\n  font-weight: normal;\r\n  opacity: 60%;\r\n}\r\n\r\n.Tech__Info__Grid p {\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n}\r\n\r\n.Tech__Info__Grid h3 {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.TechInfo__left {\r\n  grid-column: 1 / 4;\r\n  width: clamp(100%, 100%, 100%);\r\n}\r\n\r\n.TechInfo__right {\r\n  grid-column: 4 / 9 !important;\r\n  width: clamp(100%, 100%, 100%);\r\n  display: grid;\r\n  gap: 5px;\r\n  grid-template-columns: 1fr 4fr;\r\n  align-items: start;\r\n  justify-items: start;\r\n}\r\n\r\n.TechInfo__right p {\r\n  line-height: 25px;\r\n}\r\n\r\n.TechInfo__right div {\r\n  padding: 0.5em 0 1.5em 0;\r\n}\r\n\r\n.NextProject {\r\n  max-width: 68.6%;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  margin-bottom: 12.5em;\r\n}\r\n\r\n.line__New {\r\n  background: rgba(0, 0, 0, 0.5);\r\n  color: rgba(0, 0, 0, 0.5);\r\n  border-color: rgba(0, 0, 0, 0.5);\r\n  height: 1px;\r\n  cursor: pointer;\r\n}\r\n\r\n.line__New:hover {\r\n  background: red;\r\n  color: red;\r\n  border-color: red;\r\n  transition: 1s;\r\n}\r\n\r\n.NextProject h3 {\r\n  font-size: 24px;\r\n  font-weight: normal;\r\n}\r\n\r\n.NextProject h1 {\r\n  font-size: 36px;\r\n  font-weight: bolder;\r\n  opacity: 100%;\r\n  line-height: 50px;\r\n}\r\n\r\n.NextProject h2 {\r\n  font-size: 28px;\r\n  font-weight: normal;\r\n}\r\n\r\n.NextProject__Info {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n  gap: 20px;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n  padding-top: 20px;\r\n}\r\n\r\n.line__Project {\r\n  pointer-events: none;\r\n}\r\n\r\n.NextProject__Info h3 {\r\n  pointer-events: auto;\r\n  cursor: pointer;\r\n  width: fit-content;\r\n  height: fit-content;\r\n}\r\n\r\n.NextProject__Title {\r\n  grid-column: 3 / 5;\r\n  color: black !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.Top_Arrow {\r\n  display: grid;\r\n  justify-items: center;\r\n  align-items: end;\r\n  cursor: pointer;\r\n  position: fixed;\r\n  right: 7.5%;\r\n  bottom: 28.25%;\r\n}\r\n\r\n.Top_Arrow p {\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n}\r\n\r\n.Top_Arrow img {\r\n  margin-bottom: 0.5em;\r\n}\r\n\r\n.Top__Arrow__Home {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  justify-items: center;\r\n  align-items: end;\r\n  cursor: pointer;\r\n  position: fixed;\r\n  bottom: 15em;\r\n  left: 86.3%;\r\n}\r\n\r\n.Top__Arrow__Home p {\r\n  font-size: 18px;\r\n  font-weight: bolder;\r\n  grid-column: 1 / 4;\r\n}\r\n\r\n.Top__Arrow__Home img {\r\n  margin-bottom: 0.5em;\r\n  grid-column: 1 / 4;\r\n}\r\n\r\n@media all and (min-width: 1700px) {\r\n  .grid-container__footer__mobile__home {\r\n    display: none;\r\n  }\r\n\r\n  #mobile__Info {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__filter__mobile {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1440px) and (max-width: 1700px) {\r\n  .navbar-container__test__Logo {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding-top: 2.5em;\r\n    align-content: center;\r\n    align-items: end;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 2;\r\n  }\r\n  #mobile__Info {\r\n    display: none !important;\r\n  }\r\n\r\n  .grid-container__filter__mobile {\r\n    display: none !important;\r\n  }\r\n\r\n  .grid-container__footer__mobile__home {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1025px) and (max-width: 1440px) {\r\n  #Top__Arrow {\r\n    display: none !important;\r\n  }\r\n\r\n  .navbar-container__test__Logo {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    gap: 20px;\r\n    max-width: 80%;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding-top: 2.5em;\r\n    align-content: center;\r\n    align-items: end;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 2;\r\n  }\r\n\r\n  .Carousel__Info {\r\n    position: absolute;\r\n    bottom: 2.5%;\r\n    left: 10%;\r\n    width: 100vw;\r\n    max-width: 80% !important;\r\n    z-index: 1; /* Place it on top of the images or videos */\r\n    color: white;\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    justify-content: center;\r\n    align-items: start;\r\n  }\r\n\r\n  .info__item__3 {\r\n    justify-self: right;\r\n  }\r\n\r\n  .grid-container__filter__mobile {\r\n    display: none !important;\r\n  }\r\n\r\n  .grid-container__test {\r\n    max-width: 80% !important;\r\n  }\r\n\r\n  .main__Grid {\r\n    max-width: 80% !important;\r\n  }\r\n\r\n  .More__Projects__Grid {\r\n    max-width: 80% !important;\r\n  }\r\n\r\n  .grid-container__footer {\r\n    max-width: 80% !important;\r\n  }\r\n\r\n  .footer__logos__test {\r\n    grid-column: 1 / 2;\r\n    display: flex;\r\n    width: clamp(150px, 100%, 100%);\r\n    align-items: end;\r\n    justify-content: left;\r\n    gap: 2em;\r\n  }\r\n\r\n  .footer__logos__test div {\r\n    height: 2em;\r\n  }\r\n\r\n  .footer__links__test {\r\n    grid-column: 2 / 3;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: clamp(150px, 100%, 100%);\r\n    align-items: end;\r\n    gap: 0.5em;\r\n  }\r\n\r\n  .footer__links__test div span {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .footer__links__test div p {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .grid-container__footer__mobile__home {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 769px) and (max-width: 1024px) {\r\n  #Top__Arrow {\r\n    display: none !important;\r\n  }\r\n\r\n  .NextProject h3 {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .NextProject h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    opacity: 100%;\r\n    line-height: normal;\r\n  }\r\n\r\n  .NextProject h2 {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .main__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n  }\r\n\r\n  .Carousel__Info {\r\n    position: absolute;\r\n    bottom: 2.5%;\r\n    left: 5.25%;\r\n    width: 100vw;\r\n    max-width: 89.5% !important;\r\n    z-index: 1; /* Place it on top of the images or videos */\r\n    color: white;\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    justify-content: center;\r\n    align-items: start;\r\n  }\r\n\r\n  .info__item:nth-child(1) {\r\n    grid-column: 1 /2;\r\n    grid-row: 1 / 2;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(2) {\r\n    grid-column: 1 /2;\r\n    grid-row: 2 / 3;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(3) {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n  }\r\n\r\n  .filter__container {\r\n    grid-column: 2 / 5;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    min-width: 150px;\r\n    color: black;\r\n    opacity: 40%;\r\n    position: relative;\r\n  }\r\n\r\n  .grid-container__test {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__filter__mobile {\r\n    display: grid;\r\n    grid-template-rows: 1fr;\r\n    margin: 0 auto;\r\n    padding: 25px 0 25px 0;\r\n    max-width: 89.5%;\r\n    gap: 10px;\r\n    color: black;\r\n    position: relative;\r\n  }\r\n\r\n  .test__test {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .grid-container__filter__mobile h1 {\r\n    font-size: 3vw;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .info__Grid {\r\n    display: none;\r\n  }\r\n\r\n  .info__Grid__Mobile {\r\n    display: grid;\r\n    grid-template-rows: 1fr;\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 5.25%;\r\n    align-items: end;\r\n    padding-bottom: 5.25%;\r\n    transition: opacity 0.5s ease-in-out;\r\n  }\r\n\r\n  .info__item__Mobile {\r\n    color: white;\r\n    align-items: end;\r\n  }\r\n\r\n  .info__item__Mobile:nth-child(1) {\r\n    display: inline-flex;\r\n    color: white;\r\n    align-items: start;\r\n  }\r\n\r\n  .info__item__Mobile__extra {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .info__item__Mobile h1 {\r\n    font-size: clamp(4vw, 100%, 4vw);\r\n    font-weight: bold;\r\n  }\r\n\r\n  .info__item__Mobile p {\r\n    font-size: clamp(4vw, 100%, 4vw);\r\n    font-weight: normal;\r\n  }\r\n\r\n  .info__item__Mobile:nth-child(2) h1 {\r\n    color: white;\r\n    font-size: clamp(4vw, 100%, 4vw);\r\n  }\r\n\r\n  .info__item__Mobile:nth-child(2) p {\r\n    color: white;\r\n    font-size: clamp(4vw, 100%, 4vw);\r\n  }\r\n\r\n  .grid-container__footer {\r\n    display: none !important;\r\n  }\r\n\r\n  .grid-container__footer__mobile__home {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 2em 0 1em 0;\r\n    width: 89.5%;\r\n    color: black;\r\n  }\r\n\r\n  .footer__logos__test {\r\n    grid-column: 1 / 2;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .Awards__Info__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    height: 87.5svh;\r\n    align-items: end;\r\n  }\r\n\r\n  .awardsInfo {\r\n    grid-column: 1 / 5;\r\n    gap: 1em;\r\n    display: grid;\r\n    grid-template-columns: repeat(\r\n      auto-fit,\r\n      minmax(50px, 50px)\r\n    ); /* Use auto-fit */\r\n    margin: 0 auto; /* Update this line for horizontal centering */\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    width: 100%;\r\n    height: fit-content;\r\n    justify-content: center;\r\n  }\r\n\r\n  .ProjectInfo__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 20px;\r\n    justify-items: center;\r\n  }\r\n\r\n  .ProjectInfo__Grid div {\r\n    grid-column: 1 / 3;\r\n  }\r\n\r\n  .ProjectInfo__Text {\r\n    grid-column: 1 / 3 !important;\r\n    width: clamp(310px, 100%, 100%);\r\n    padding: 1em 0 1em 0;\r\n  }\r\n\r\n  .ProjectInfo__Text h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .ProjectInfo__Text p {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .Tech__Info__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 1.5em;\r\n  }\r\n\r\n  .Tech__Info__Grid h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    line-height: normal;\r\n  }\r\n\r\n  .Tech__Info__Grid h2 {\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .Tech__Info__Grid p {\r\n    font-size: 16px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .Tech__Info__Grid h3 {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .TechInfo__left {\r\n    grid-column: 1 / 3;\r\n    width: clamp(150px, 100%, 100%);\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .TechInfo__left h2 {\r\n    padding-left: 0;\r\n  }\r\n\r\n  .TechInfo__right {\r\n    grid-column: 1 / 3 !important;\r\n    width: clamp(310px, 100%, 100%);\r\n    display: grid;\r\n    grid-template-columns: 1fr 4fr;\r\n    padding-bottom: 2.5em;\r\n    align-items: start;\r\n  }\r\n\r\n  .TechInfo__right div {\r\n    padding: 0em 0 0em 0;\r\n  }\r\n\r\n  .NextProject {\r\n    max-width: 89.5%;\r\n    margin: 0 auto;\r\n    margin-bottom: 0px;\r\n    padding: 0;\r\n    margin-bottom: 5em;\r\n  }\r\n\r\n  .NextProject__Info {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr;\r\n    gap: 0px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    padding-top: 1.5em;\r\n    padding-bottom: 3em;\r\n  }\r\n\r\n  .NextProject__Title {\r\n    grid-column: 2 / 3;\r\n    justify-self: end;\r\n  }\r\n\r\n  .NextProject__Title h2 {\r\n    padding-left: 0;\r\n  }\r\n\r\n  .Top_Arrow {\r\n    display: none !important;\r\n  }\r\n\r\n  .Top_Arrow__Home {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 426px) and (max-width: 768px) {\r\n  .NextProject h3 {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .NextProject h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    opacity: 100%;\r\n    line-height: normal;\r\n  }\r\n\r\n  .NextProject h2 {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .Carousel__Info {\r\n    position: absolute;\r\n    bottom: 2.5%;\r\n    left: 5.25%;\r\n    width: 100vw;\r\n    max-width: 89.5% !important;\r\n    z-index: 1; /* Place it on top of the images or videos */\r\n    color: white;\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    justify-content: center;\r\n    align-items: start;\r\n  }\r\n\r\n  .info__item:nth-child(1) {\r\n    grid-column: 1 /2;\r\n    grid-row: 1 / 2;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(2) {\r\n    grid-column: 1 /2;\r\n    grid-row: 2 / 3;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(3) {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n  }\r\n\r\n  .Awards__Info__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    height: 87.5svh;\r\n    align-items: end;\r\n  }\r\n\r\n  .Tech__Info__Grid h2 {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .Tech__Info__Grid p {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .Tech__Info__Grid h3 {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .awardsInfo {\r\n    grid-column: 1 / 2;\r\n    gap: 1em;\r\n    display: grid;\r\n    grid-template-columns: repeat(\r\n      auto-fit,\r\n      minmax(50px, 50px)\r\n    ); /* Use auto-fit */\r\n    margin: 0 auto; /* Update this line for horizontal centering */\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    width: 100%;\r\n    height: fit-content;\r\n    justify-content: center;\r\n  }\r\n\r\n  .NextProject {\r\n    max-width: 89.5%;\r\n    margin: 0 auto;\r\n    margin-bottom: 0px;\r\n    padding: 0;\r\n    margin-bottom: 5em;\r\n  }\r\n\r\n  .NextProject__Info {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr;\r\n    gap: 0px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .NextProject__Title {\r\n    grid-column: 2 / 3;\r\n    justify-self: end;\r\n  }\r\n\r\n  .NextProject__Title h2 {\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 768px) {\r\n  #Top__Arrow {\r\n    display: none !important;\r\n  }\r\n\r\n  .NextProject h3 {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .NextProject h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    opacity: 100%;\r\n    line-height: normal;\r\n  }\r\n\r\n  .NextProject h2 {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .main__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n  }\r\n\r\n  .Carousel__Info {\r\n    max-width: 89.5%;\r\n  }\r\n\r\n  .filter__container {\r\n    grid-column: 2 / 5;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    min-width: 150px;\r\n    color: black;\r\n    opacity: 40%;\r\n    position: relative;\r\n  }\r\n\r\n  .grid-container__test {\r\n    display: none;\r\n  }\r\n\r\n  .grid-container__filter__mobile {\r\n    display: grid;\r\n    grid-template-rows: 1fr;\r\n    margin: 0 auto;\r\n    padding: 25px 0 25px 0;\r\n    max-width: 89.5%;\r\n    gap: 10px;\r\n    color: black;\r\n    position: relative;\r\n  }\r\n\r\n  .test__test {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .grid-container__filter__mobile h1 {\r\n    font-size: 4vw;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .info__Grid {\r\n    display: none;\r\n  }\r\n\r\n  .info__Grid__Mobile {\r\n    display: grid;\r\n    grid-template-rows: 1fr;\r\n    grid-gap: 20px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 5.25%;\r\n    align-items: end;\r\n    padding-bottom: 5.25%;\r\n    transition: opacity 0.5s ease-in-out;\r\n  }\r\n\r\n  .info__item__Mobile {\r\n    color: white;\r\n    align-items: end;\r\n  }\r\n\r\n  .info__item__Mobile:nth-child(1) {\r\n    display: inline-flex;\r\n    color: white;\r\n    align-items: start;\r\n  }\r\n\r\n  .info__item__Mobile__extra {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .info__item__Mobile h1 {\r\n    font-size: clamp(4vw, 100%, 4vw);\r\n    font-weight: bold;\r\n  }\r\n\r\n  .info__item__Mobile p {\r\n    font-size: clamp(4vw, 100%, 4vw);\r\n    font-weight: normal;\r\n  }\r\n\r\n  .info__item__Mobile:nth-child(2) h1 {\r\n    color: white;\r\n    font-size: clamp(4vw, 100%, 4vw);\r\n  }\r\n\r\n  .info__item__Mobile:nth-child(2) p {\r\n    color: white;\r\n    font-size: clamp(4vw, 100%, 4vw);\r\n  }\r\n\r\n  .grid-container__footer {\r\n    display: none !important;\r\n  }\r\n\r\n  .grid-container__footer__mobile__home {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 2em 0 1em 0;\r\n    width: 89.5%;\r\n    color: black;\r\n  }\r\n\r\n  .footer__logos__test {\r\n    grid-column: 1 / 2;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: clamp(150px, 100%, 100%);\r\n  }\r\n\r\n  .ProjectInfo__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 20px;\r\n    justify-items: center;\r\n  }\r\n\r\n  .ProjectInfo__Grid div {\r\n    grid-column: 1 / 3;\r\n  }\r\n\r\n  .ProjectInfo__Text {\r\n    grid-column: 1 / 3 !important;\r\n    width: clamp(310px, 100%, 100%);\r\n    padding: 1em 0 1em 0;\r\n  }\r\n\r\n  .ProjectInfo__Text h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .ProjectInfo__Text p {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .Tech__Info__Grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(150px, 1fr));\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    padding-top: 1.5em;\r\n  }\r\n\r\n  .Tech__Info__Grid h1 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    line-height: normal;\r\n  }\r\n\r\n  .Tech__Info__Grid h2 {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    opacity: 60%;\r\n  }\r\n\r\n  .Tech__Info__Grid p {\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .Tech__Info__Grid h3 {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .TechInfo__left {\r\n    grid-column: 1 / 3;\r\n    width: clamp(150px, 100%, 100%);\r\n    padding-bottom: 1em;\r\n  }\r\n\r\n  .TechInfo__left h2 {\r\n    padding-left: 0;\r\n  }\r\n\r\n  .TechInfo__right {\r\n    grid-column: 1 / 3 !important;\r\n    width: clamp(310px, 100%, 100%);\r\n    display: grid;\r\n    grid-template-columns: 1fr 4fr;\r\n    padding-bottom: 2.5em;\r\n    align-items: start;\r\n  }\r\n\r\n  .TechInfo__right div {\r\n    padding: 0em 0 0em 0;\r\n  }\r\n\r\n  .Top_Arrow {\r\n    display: none !important;\r\n  }\r\n\r\n  .Top_Arrow__Home {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 376px) and (max-width: 425px) {\r\n  .NextProject h3 {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .NextProject h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    opacity: 100%;\r\n    line-height: normal;\r\n  }\r\n\r\n  .NextProject h2 {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .Carousel__Info {\r\n    position: absolute;\r\n    bottom: 2.5%;\r\n    left: 5.25%;\r\n    width: 100vw;\r\n    max-width: 89.5% !important;\r\n    z-index: 1; /* Place it on top of the images or videos */\r\n    color: white;\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    justify-content: center;\r\n    align-items: start;\r\n  }\r\n\r\n  .info__item:nth-child(1) {\r\n    grid-column: 1 /2;\r\n    grid-row: 1 / 2;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(2) {\r\n    grid-column: 1 /2;\r\n    grid-row: 2 / 3;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(3) {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n  }\r\n\r\n  .Awards__Info__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    height: 87.5svh;\r\n    align-items: end;\r\n  }\r\n\r\n  .awardsInfo {\r\n    grid-column: 1 / 2;\r\n    gap: 1em;\r\n    display: grid;\r\n    grid-template-columns: repeat(\r\n      auto-fit,\r\n      minmax(50px, 50px)\r\n    ); /* Use auto-fit */\r\n    margin: 0 auto; /* Update this line for horizontal centering */\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    width: 100%;\r\n    height: fit-content;\r\n    justify-content: center;\r\n  }\r\n\r\n  .NextProject {\r\n    max-width: 89.5%;\r\n    margin: 0 auto;\r\n    margin-bottom: 0px;\r\n    padding: 0;\r\n    margin-bottom: 5em;\r\n  }\r\n\r\n  .NextProject__Info {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr;\r\n    gap: 0px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .NextProject__Title {\r\n    grid-column: 2 / 3;\r\n    justify-self: end;\r\n  }\r\n\r\n  .NextProject__Title h2 {\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 321px) and (max-width: 375px) {\r\n  .NextProject h3 {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .NextProject h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    opacity: 100%;\r\n    line-height: normal;\r\n  }\r\n\r\n  .NextProject h2 {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .Carousel__Info {\r\n    position: absolute;\r\n    bottom: 2.5%;\r\n    left: 5.25%;\r\n    width: 100vw;\r\n    max-width: 89.5% !important;\r\n    z-index: 1; /* Place it on top of the images or videos */\r\n    color: white;\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    justify-content: center;\r\n    align-items: start;\r\n  }\r\n\r\n  .info__item:nth-child(1) {\r\n    grid-column: 1 /2;\r\n    grid-row: 1 / 2;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(2) {\r\n    grid-column: 1 /2;\r\n    grid-row: 2 / 3;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(3) {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n  }\r\n\r\n  .Awards__Info__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    height: 87.5svh;\r\n    align-items: end;\r\n  }\r\n\r\n  .awardsInfo {\r\n    grid-column: 1 / 2;\r\n    gap: 1em;\r\n    display: grid;\r\n    grid-template-columns: repeat(\r\n      auto-fit,\r\n      minmax(50px, 50px)\r\n    ); /* Use auto-fit */\r\n    margin: 0 auto; /* Update this line for horizontal centering */\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    width: 100%;\r\n    height: fit-content;\r\n    justify-content: center;\r\n  }\r\n\r\n  .NextProject {\r\n    max-width: 89.5%;\r\n    margin: 0 auto;\r\n    margin-bottom: 0px;\r\n    padding: 0;\r\n    margin-bottom: 5em;\r\n  }\r\n\r\n  .NextProject__Info {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr;\r\n    gap: 0px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .NextProject__Title {\r\n    grid-column: 2 / 3;\r\n    justify-self: end;\r\n  }\r\n\r\n  .NextProject__Title h2 {\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media all and (max-width: 320px) {\r\n  .NextProject h3 {\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .NextProject h1 {\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    opacity: 100%;\r\n    line-height: normal;\r\n  }\r\n\r\n  .NextProject h2 {\r\n    font-size: 18px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .Carousel__Info {\r\n    position: absolute;\r\n    bottom: 2.5%;\r\n    left: 5.25%;\r\n    width: 100vw;\r\n    max-width: 89.5% !important;\r\n    z-index: 1; /* Place it on top of the images or videos */\r\n    color: white;\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n    grid-gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    justify-content: center;\r\n    align-items: start;\r\n  }\r\n\r\n  .info__item:nth-child(1) {\r\n    grid-column: 1 /2;\r\n    grid-row: 1 / 2;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(2) {\r\n    grid-column: 1 /2;\r\n    grid-row: 2 / 3;\r\n    width: auto;\r\n  }\r\n\r\n  .info__item:nth-child(3) {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 2;\r\n  }\r\n\r\n  .Awards__Info__Grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    gap: 10px;\r\n    margin: 0 auto;\r\n    padding: 0;\r\n    max-width: 89.5%;\r\n    position: relative;\r\n    height: 87.5svh;\r\n    align-items: end;\r\n  }\r\n\r\n  .awardsInfo {\r\n    grid-column: 1 / 2;\r\n    gap: 1em;\r\n    display: grid;\r\n    grid-template-columns: repeat(\r\n      auto-fit,\r\n      minmax(50px, 50px)\r\n    ); /* Use auto-fit */\r\n    margin: 0 auto; /* Update this line for horizontal centering */\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    width: 100%;\r\n    height: fit-content;\r\n    justify-content: center;\r\n  }\r\n\r\n  .NextProject {\r\n    max-width: 89.5%;\r\n    margin: 0 auto;\r\n    margin-bottom: 0px;\r\n    padding: 0;\r\n    margin-bottom: 5em;\r\n  }\r\n\r\n  .NextProject__Info {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr;\r\n    gap: 0px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .NextProject__Title {\r\n    grid-column: 2 / 3;\r\n    justify-self: end;\r\n  }\r\n\r\n  .NextProject__Title h2 {\r\n    padding-left: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
